export const ROLES = {
    Root: "Root",
    Admin: 'Admin',
    User: 'User',
    Guest: 'Guest',
}